import { nanoid } from 'nanoid';
import { WELCOME_MOBILE_STORIES as WelcomeType } from '../../../../../poll';

export function generateWelcome(overrides: Partial<WelcomeType['data']> = {}): WelcomeType {
  return {
    id: nanoid(10),
    data: {
      type: 'WELCOME_MOBILE_STORIES' as const,
      title: '',
      text: '',
      cta: 'Перейти к опросу',
      disclaimer: '',
      ...overrides,
    },
  };
}
